/**
 * Public storefront presence — sole FE signal for Shipping-only vs storefront.
 * Never infer ONLINE_ONLY from null lat/lng or null location (A13b / D1).
 */

export const SALES_POINT_CUSTOMER_PRESENCE = {
  STOREFRONT: 'STOREFRONT',
  ONLINE_ONLY: 'ONLINE_ONLY',
} as const;

export type SalesPointCustomerPresence =
  (typeof SALES_POINT_CUSTOMER_PRESENCE)[keyof typeof SALES_POINT_CUSTOMER_PRESENCE];

/** Fail-closed: unknown / omit → STOREFRONT (never invent ONLINE_ONLY). */
export function parseSalesPointCustomerPresence(
  raw: unknown,
): SalesPointCustomerPresence {
  if (raw === SALES_POINT_CUSTOMER_PRESENCE.ONLINE_ONLY) {
    return SALES_POINT_CUSTOMER_PRESENCE.ONLINE_ONLY;
  }
  return SALES_POINT_CUSTOMER_PRESENCE.STOREFRONT;
}

export function isOnlineOnlyCustomerPresence(
  presence: SalesPointCustomerPresence | null | undefined,
): boolean {
  return presence === SALES_POINT_CUSTOMER_PRESENCE.ONLINE_ONLY;
}

/** i18n key — Shipping-only label (never locationMissing for ONLINE_ONLY). */
export const CUSTOMER_PRESENCE_SHIPPING_ONLY_I18N_KEY =
  'customerPresence.shippingOnly' as const;

/** i18n key — map empty when geo view omits shipping-only shops (A19). */
export const CUSTOMER_PRESENCE_MAP_OMITS_SHIPPING_ONLY_I18N_KEY =
  'customerPresence.mapOmitsShippingOnly' as const;

/** i18n key — nearby empty body when geo filter omits shipping-only (A19). */
export const CUSTOMER_PRESENCE_NEARBY_OMITS_SHIPPING_ONLY_I18N_KEY =
  'customerPresence.nearbyOmitsShippingOnly' as const;